import { Outlet, Navigate, NavLink } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';
import { useOrgBootstrap } from '@/hooks/useOrganization';

const MOBILE_NAV = [
  { to: '/', icon: 'dashboard', label: 'Dash' },
  { to: '/formats', icon: 'grid_view', label: 'Formats' },
  { to: '/campaigns', icon: 'campaign', label: 'Camp' },
  { to: '/creatives', icon: 'auto_awesome', label: 'Creatives' },
];

export default function AppShell() {
  const { ready, needsSetup, loading } = useOrgBootstrap();

  // Fetching /users/me for the first time (no org stored)
  if (loading) {
    return (
      <div className="flex h-screen items-center justify-center bg-surface">
        <span className="material-symbols-outlined text-primary animate-spin text-4xl">
          progress_activity
        </span>
      </div>
    );
  }

  // New user with no orgs → go to setup
  if (needsSetup) {
    return <Navigate to="/setup" replace />;
  }

  // Org resolved (either from localStorage or from /users/me)
  if (ready) {
    return (
      <div className="flex min-h-screen bg-surface text-on-surface">
        <Sidebar />
        <Header />
        <main className="md:ml-64 mt-16 mb-16 md:mb-0 pb-safe flex-1 min-h-[calc(100vh-4rem)] flex flex-col pt-4 md:pt-0">
          <Outlet />
        </main>

        {/* Mobile Navigation */}
        <nav className="md:hidden fixed bottom-0 left-0 right-0 bg-white border-t border-stone-200 flex justify-around p-1 z-50 items-center">
          {MOBILE_NAV.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === '/'}
              className={({ isActive }) =>
                `flex flex-col items-center justify-center w-16 h-14 rounded-lg transition-colors ${
                  isActive
                    ? 'text-primary font-bold'
                    : 'text-on-surface-variant hover:text-primary hover:bg-primary-container/20'
                }`
              }
            >
              {({ isActive }) => (
                <>
                  <span
                    className="material-symbols-outlined text-[20px] mb-0.5"
                    style={isActive ? { fontVariationSettings: "'FILL' 1" } : undefined}
                  >
                    {item.icon}
                  </span>
                  <span className="text-[9px] truncate">{item.label}</span>
                </>
              )}
            </NavLink>
          ))}
        </nav>
      </div>
    );
  }

  // Fallback (e.g. /users/me errored) — show error state rather than infinite spinner
  return (
    <div className="flex h-screen flex-col items-center justify-center gap-4 bg-surface">
      <span className="material-symbols-outlined text-error text-4xl">warning</span>
      <p className="text-on-surface-variant text-sm">
        Could not resolve your workspace. Please refresh and try again.
      </p>
    </div>
  );
}
